export const BlogHomeHeroSection = () => (
  <section className="w-full bg-lupine-50 overflow-hidden px-4 pt-10 md:pt-20">
    <div className="max-w-5xl mx-auto">
      <h1 className="font-sans text-3xl md:text-5xl font-medium text-plum-950 -tracking-[0.03em] mb-8">
        Wolfia Blog
      </h1>
      <p className="font-sans text-lg md:text-2xl text-fog-900 -tracking-[0.02em]">
        The latest news about Wolfia and AI compliance.
      </p>
      <hr className="border-b border-fog-100 mt-16" />
    </div>
  </section>
);
